import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { DataModelTypeEntity } from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import {
  ApiHttpProxyService,
  ForwardProxyMicroservice,
} from '@flowx/designer/shared/api/api-http-proxy.service'
import {
  AppResource,
  ApplicationResourceType,
  ProxyApiAction,
} from '@flowx/designer/shared/entities/application.entity'

export interface ArchitectApplyResourceIds {
  resourceId: string
  resourceDefinitionId: string
}

export interface ArchitectApplyReference {
  targetFlowxUuid?: string
  targetResourceDefinitionId?: string
  appId?: string
}

export interface ArchitectApplyAttribute {
  flowxUuid: string
  name: string
  type: string
  multiInstance: boolean
  description?: string
  exampleValue?: string
  useInReporting?: boolean
  isSensitive?: boolean
  reference?: ArchitectApplyReference
}

export interface ArchitectApplyEntity {
  flowxUuid: string
  name: string
  description?: string
  exampleValue?: string
  attributes: ArchitectApplyAttribute[]
}

export interface ArchitectApplyPayload {
  newResourceNames: string[]
  existingResources: Record<string, ArchitectApplyResourceIds>
  action: ProxyApiAction
  // protect existing data types: the BE keeps saved attributes intact and only appends new ones,
  // never deleting a type/attribute or changing an attribute type.
  protectExisting: boolean
  payload: {
    exportVersion: number
    dataEntities: ArchitectApplyEntity[]
  }
}

@Injectable({ providedIn: 'root' })
export class AiArchitectApiService extends ApiHttpProxyService {
  private url = 'api/project-data-type/bulk-create-update'

  applyDataModel(body: ArchitectApplyPayload): Observable<AppResource<DataModelTypeEntity[]>> {
    return this.post(this.url, body, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.ProjectDataType,
      applyBulk: true,
    })
  }
}
